import { render, staticRenderFns } from "./CreateContract.yaml?vue&type=template&id=2cf8c3fc&component"
import script from "./CreateContract.yaml?vue&type=script&lang=ts&component"
export * from "./CreateContract.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports